module.exports = __webpack_public_path__ + "static/media/icon-supplies-cotton-balls.7055cb20.svg";